<template>
  <div style="margin-top:10px;">
    <mu-row>
      <mu-col desktop="5"></mu-col>
      <mu-col desktop="15">
        <mu-select-field style="width:120px;" v-model="year">
          <mu-menu-item v-for="item,index in select.year.options"
          :value="item.id" :title="item.text"/>
        </mu-select-field>
      </mu-col>
      <mu-col desktop="20">
        <mu-select-field style="width:120px;" v-model="month">
          <mu-menu-item v-for="item,index in select.month.options"
          :value="item.id" :title="item.text"/>
        </mu-select-field>
      </mu-col>
      <mu-col desktop="15"></mu-col>
      <mu-col desktop="10">
        <div style="height:56px; line-height:56px;color:red;" v-if="residue < 4">剩余{{residue}}次</div>
        <div style="height:56px; line-height:56px;" v-else > 训练次数</div>
      </mu-col>
      <mu-col desktop="30" >
        <mu-linear-progress style="margin-top:20px;" :size="15" :color="timeWarn"
        mode="determinate" :value="residue" :max="totalAll"/>
        <div class="line-font-style">{{ residue }}/{{ total }}</div>
      </mu-col>
      <mu-col desktop="5"></mu-col>
    </mu-row>
    <mu-row>
      <mu-col desktop="100">
        <digEchart v-if="showChart" :xData="trainDate" :index="index" :yData="trainLists"></digEchart>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>
  import Vue from 'vue'
  import digEchart from './digEchart.vue'
  export default ({
    data() {
      return{
        select: GLOBAL.selectOption,
        showChart: false,
        trainDate: [],
        trainLists: [],
        index: '100',
        year: 0,
        month: 0,
        residue: 0,//有效训练次数
        total:100,   //总次数
        alreadyTrainTimes:0,//已经训练次数
      }
    },
    props:[],
    components: {
      digEchart
    },
    computed:{
      timeWarn(){
        if(this.total - this.alreadyTrainTimes < 4) {
          return 'red';
        }
      },
      totalAll(){
        return this.total;
      }
    },
    mounted(){
      this.showChart = true;
      this.fetch();
      this.getNowTrain();
    },
    watch:{
      year:function (newVal,oldVal) {//监听年份的变化
        var self = this;
        let year = self.select.year.options[newVal].year;
        let month = self.select.month.options[self.month].month;
        this.getTrainFrequence(year,month);
        self.$parent.year = year;//给父页面传参，年份
        self.$parent.month = month;//给父页面传参，月份
      },
      month:function (newVal,oldVal){//监听月份的变化
        var self = this;
        let year = self.select.year.options[self.year].year;
        let month = self.select.month.options[newVal].month;
        this.getTrainFrequence(year,month);
        self.$parent.year = year;//给父页面传参，年份
        self.$parent.month = month;//给父页面传参，月份
      }
    },
    methods : {
      fetch(){//初始化获取训练次数和总次数
        var self = this;
        this.$http.get('/api/Users/me').then(
          function (res) {
            self.$http.get(GLOBAL.ORDER+'goods/'+res.data.org_uuid+'/available').then(
              function (res) {
                for(var val in res.data){
                  switch(res.data[val].code){
                    case 'EM'://判断是否为电子药类型
                      self.residue = res.data[val].residue;//已训练次数
                      self.total = res.data[val].total;//总次数
                      console.log(self.total)
                      self.alreadyTrainTimes = self.total-self.residue;
                      break;
                    default:
                      break;
                  }
                }
              });
          },
          function(res){
            console.log(res)
          }
        );
      },
      getNowTrain(){//页面初始化，显示当前年月并查询出结果
        var self = this;
        let nowDate = new Date();
        let nowYear = nowDate.getFullYear();
        let nowMonth = nowDate.getMonth()+1;
        self.getTrainFrequence(nowYear,nowMonth);//当前年月显示曲线

        for(let y of self.select.year.options){//初始化下拉框的默认选择年份为当前年份
          if(y.year == nowYear){
            self.year = y.id;
          }
        }
        for(let m of self.select.month.options){//初始化下拉框的默认选择月份为当前月份
          if(m.month == nowMonth){
            self.month = m.id;
          }
        }
      },
      getTrainFrequence(year,month){//动态更加年月查询训练频率
        var self = this;
        self.$http.get('/api/Train/statisticsTM',
          {
            params:{
              "year":year,
              "month":month
            }
          }).then(
          function (res) {
            let trueData = res.data.data;//真实数据
            self.trainDate = [];
            self.trainLists = [];
            for(let data in trueData){
              self.trainDate.push(data.substr(5));//横坐标
              self.trainLists.push(trueData[data]['counts']);//纵坐标
            }
            self.showChart = false;//通过子组件上的v-if值改变，重新渲染曲线
          },
          function(error){
            console.log(error)//访问接口出错信息
          }).then(function(){
            self.showChart = true;//通过子组件上的v-if值改变，重新渲染曲线
        });
      }
    }
  })
</script>
<style scoped>
  .line-font-style{
    position:relative;
    z-index:99;
    margin-top:-16px;
    font-size: 12px;
    color: #fff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// trainTimes.vue?00ec7a5c